<template>
	<v-container class="d-flex flex-column align-start flex-1" fluid fill-height pa-0
		:class="$store.meetingStore.state.selectedType === 2 || $store.meetingStore.state.selectedType === 3 ? 'scrollable-list-bak':''">
		<FullHeader />
		<MeetingsContainer />
	</v-container>
</template>

<script>
import FullHeader from '../../Globals/Headers/FullHeader'
import MeetingsContainer from './MeetingsContainer'

export default {
	name: 'MeetingsIndex',
	components: {FullHeader, MeetingsContainer},
	data: () => ({
		loading: false
	}),
	mounted(){
	},
	methods: {
	}
};
</script>


<style>
	.scrollable-list{
		flex: 1 1 auto;
		height: 100%;
	}
	.scrollable-list #consultas-container{
		flex: 1 1 auto;
		height: 100%;
	}
</style>